import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, SmartphoneIcon, BotIcon, LinkIcon, SearchIcon, PackageIcon, ZapIcon, CheckIcon, XIcon, PlayIcon } from 'lucide-react';
const LOOM_VIDEO_ID = '7a85a1937047412cbbda6fc84aee34a1';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const erpLogos = [{
  name: 'Thruline',
  logo: 'https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/logo-dark-trans.png'
}, {
  name: 'Acumatica',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/accumatica.jpg"
}, {
  name: 'Dynamics 365',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/dynamics.png"
}, {
  name: 'Epicor',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/epicor.png"
}, {
  name: 'NetSuite',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/netsuite.jpg"
}, {
  name: 'Infor',
  logo: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/png-transparent-infor-hd-logo-thumbnail.png"
}];
function ERPLogoMarquee() {
  const allLogos = [...erpLogos, ...erpLogos];
  return <div className="relative mt-10" data-id="element-1787" data-mp="1ewthxs33p8pg">
      {/* Left fade */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-navy to-transparent z-10 pointer-events-none" data-id="element-1788" data-mp="1ezfoboe99i63" />
      {/* Right fade */}
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-navy to-transparent z-10 pointer-events-none" data-id="element-1789" data-mp="3jh72x8xbpts" />

      <div className="flex animate-marquee items-center" data-id="element-1790" data-mp="3fkxv5d0e5jy2">
        {allLogos.map((erp, index) => <div key={`${erp.name}-${index}`} className="flex-shrink-0 mx-12 flex items-center justify-center" data-id="element-1791" data-mp="3bknk3lxqs3cc" data-mpi={index}>
          
            <img src={erp.logo} alt={erp.name} className="h-10 w-auto max-w-[180px] object-contain transition-opacity duration-300" style={{
          filter: 'grayscale(1) invert(1)',
          mixBlendMode: 'screen',
          opacity: 0.5
        }} onMouseEnter={e => {
          e.currentTarget.style.opacity = '0.9';
        }} onMouseLeave={e => {
          e.currentTarget.style.opacity = '0.5';
        }} data-id="element-1792" data-mp="36r2m3tw5f9d5" />
          
          </div>)}
      </div>
    </div>;
}
export function ReceiveProPage() {
  const [showDemoVideo, setShowDemoVideo] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-navy text-white font-sans" data-id="element-1793" data-mp="h4d3xdpzcyx1">
      {/* ── HERO SECTION ── */}
      <section className="relative w-full min-h-screen flex items-center justify-center pt-32 pb-24 px-6 overflow-hidden bg-navy text-center" data-id="element-1794" data-mp="oo4fslbqs82g">
        <div className="absolute top-[-200px] left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-blue-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-1795" data-mp="tl4nf0o8pivo" />

        <div className="relative z-10 max-w-4xl mx-auto" data-id="element-1796" data-mp="13d0libqbt8zw">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-blue-500/20 bg-blue-500/10 text-blue-400 text-sm font-medium mb-8" data-id="element-1797" data-mp="13elgg2gjytya">
            
            <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-1798" data-mp="jpb14pkpyb0p" />
            Now available as a standalone product
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tight mb-6" data-id="element-1799" data-mp="1v3evvxz4s36t">
            
            Your dock team should be moving pallets,{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-br from-blue-400 to-teal-400" data-id="element-1800" data-mp="1ylm1cx2rz1nk">
              not typing into an ERP
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-lg sm:text-xl text-white/70 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-1801" data-mp="2cjamm60r8at5">
            
            ReceivePro turns a photo of a packing slip into a completed
            receiving record. An AI agent handles the matching, the receiving,
            and the ERP sync — so your team can scan and walk away.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-1802" data-mp="39ybxtl7jv1mc">
            
            <a href="https://calendly.com/alex-thruline/sales-call" className="inline-flex items-center justify-center px-8 py-3.5 rounded-xl bg-blue-500 text-white font-semibold text-base hover:bg-blue-400 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(59,130,246,0.3)]" data-id="element-1803" data-mp="35vxez13vs1v2">
              
              Get a Demo
            </a>
            <button onClick={() => setShowDemoVideo(true)} className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl border border-white/20 text-white font-semibold text-base hover:border-white/40 hover:bg-white/[0.03] transition-all" data-id="element-1804" data-mp="2i5kz942e90tx">
              
              <PlayIcon className="w-4 h-4" data-id="element-1805" data-mp="2d7rpk11vtoow" />
              See Demo Video
            </button>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex items-center justify-center gap-2 text-sm text-white/40" data-id="element-1806" data-mp="iu755mxtbvah">
            
            <ZapIcon className="w-4 h-4" data-id="element-1807" data-mp="51zco7dkaqhl" />
            Works with Thruline, NetSuite, Epicor, SAP, and more — no ERP switch
            required
          </motion.p>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section id="how-it-works" className="relative w-full bg-navy-light py-24 px-6" data-id="element-1808" data-mp="xn90n94i7wuk">
        
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-1809" data-mp="ssd90a36jbhz" />
        <div className="max-w-6xl mx-auto" data-id="element-1810" data-mp="3dh0zjgxuweb0">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} data-id="element-1811" data-mp="3dhsvisvd8e1t">
            
            <motion.div variants={fadeUp} className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-4" data-id="element-1812" data-mp="2ye9cylpdp2t7">
              
              How It Works
            </motion.div>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4" data-id="element-1813" data-mp="38b460p2vub03">
              
              Scan the packing slip. Walk to the next box.
            </motion.h2>
            <motion.p variants={fadeUp} className="text-lg text-white/70 max-w-2xl mb-12 leading-relaxed" data-id="element-1814" data-mp="3h2xrmpx9qbwj">
              
              ReceivePro replaces manual data entry with a single photo. The AI
              agent does everything else — automatically.
            </motion.p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1815" data-mp="3w1rsqghgj56p">
              {[{
              num: '01',
              title: 'Scan',
              desc: "Your dock worker photographs the bill of lading or packing slip with their phone. That's their only job.",
              tag: 'User — 10 seconds',
              tagColor: 'bg-blue-500/10 text-blue-400'
            }, {
              num: '02',
              title: 'Extract',
              desc: 'AI reads the document and pulls out the PO number, line items, quantities, units of measure, and tracking number.',
              tag: 'Agent — automatic',
              tagColor: 'bg-purple-500/10 text-purple-400'
            }, {
              num: '03',
              title: 'Match & Receive',
              desc: 'The agent searches your ERP for the matching PO, reconciles quantities, and creates the receiving transaction — all without human involvement.',
              tag: 'Agent — automatic',
              tagColor: 'bg-purple-500/10 text-purple-400'
            }, {
              num: '04',
              title: 'Sync & Confirm',
              desc: 'The receipt syncs to your ERP. A push notification confirms completion. Your inventory is updated in minutes, not hours.',
              tag: 'System — synced to ERP',
              tagColor: 'bg-teal-500/10 text-teal-400'
            }].map((step, i) => <motion.div key={i} variants={fadeUp} className="bg-white/[0.02] border border-white/10 rounded-2xl p-6 transition-all hover:border-blue-500/30 hover:bg-white/[0.04] hover:-translate-y-1" data-id="element-1816" data-mp="1hdd29iydf03b" data-mpi={i}>
                
                  <div className="font-mono text-xs text-blue-400 bg-blue-500/10 w-8 h-8 rounded-lg flex items-center justify-center mb-4 font-bold" data-id="element-1817" data-mp="17edq3qeecmbk">
                    {step.num}
                  </div>
                  <h3 className="text-lg font-semibold mb-2" data-id="element-1818" data-mp="20447c8bbs4bw">{step.title}</h3>
                  <p className="text-sm text-white/70 leading-relaxed mb-4" data-id="element-1819" data-mp="1lf7zab99qrba">
                    {step.desc}
                  </p>
                  <span className={`font-mono text-[10px] px-2.5 py-1 rounded-md inline-block ${step.tagColor}`} data-id="element-1820" data-mp="1qcztxd1asrj6">
                  
                    {step.tag}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section id="features" className="relative w-full bg-navy py-24 px-6" data-id="element-1821" data-mp="2rg4jlz626d2q">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-1822" data-mp="2vg6m2ajmbaj2" />
        <div className="max-w-6xl mx-auto" data-id="element-1823" data-mp="2hjjc976kgpvq">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} data-id="element-1824" data-mp="2mfqm3b232liy">
            
            <motion.div variants={fadeUp} className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-4" data-id="element-1825" data-mp="27psuel4y3dp0">
              
              What ReceivePro Does
            </motion.div>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4" data-id="element-1826" data-mp="1yp4efkvzr39h">
              
              Everything between the dock and the ERP — automated
            </motion.h2>
            <motion.p variants={fadeUp} className="text-lg text-white/70 max-w-2xl mb-12 leading-relaxed" data-id="element-1827" data-mp="1trkzeirgymgh">
              
              ReceivePro isn't another WMS module. It's a focused tool that does
              one thing exceptionally well: turn paper receipts into ERP
              transactions.
            </motion.p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1828" data-mp="1k59xf51700tv">
              {[{
              icon: SmartphoneIcon,
              title: 'Mobile-First Capture',
              desc: 'Full-screen camera viewfinder optimized for warehouse environments. Large touch targets for gloved hands. Flash for low-light docks. Scan box after box without waiting.',
              iconBg: 'bg-blue-500/10 text-blue-400'
            }, {
              icon: BotIcon,
              title: 'AI Agent Matching',
              desc: "The agent searches across your purchasing systems using a cascading match strategy — PO number, vendor + parts, tracking number. It doesn't just look up; it reasons.",
              iconBg: 'bg-purple-500/10 text-purple-400'
            }, {
              icon: LinkIcon,
              title: 'Cross-System Record Linking',
              desc: 'Every receiving record links to the PO, Purchase Request, Receipt Ticket, Transportation Ticket, and Carrier Tracking — all clickable, all in one view.',
              iconBg: 'bg-teal-500/10 text-teal-400'
            }, {
              icon: SearchIcon,
              title: 'Inspection Notices',
              desc: 'When a received item requires quality inspection, ReceivePro auto-generates an inspection notice and notifies your QA team. No manual handoff, no missed inspections.',
              iconBg: 'bg-amber-500/10 text-amber-400'
            }, {
              icon: PackageIcon,
              title: 'Carrier Tracking Enrichment',
              desc: 'The agent queries UPS, FedEx, USPS, and DHL using the extracted tracking number. Delivery confirmation, package count, signed-by name, and proof of delivery — pulled automatically.',
              iconBg: 'bg-blue-500/10 text-blue-400'
            }, {
              icon: ZapIcon,
              title: 'Multi-Scan Queue',
              desc: 'Dock workers scan multiple shipments in rapid succession. Each scan enters the pipeline independently. The camera comes right back — no waiting on processing screens.',
              iconBg: 'bg-purple-500/10 text-purple-400'
            }].map((feature, i) => {
              const IconComp = feature.icon;
              return <motion.div key={i} variants={fadeUp} className="bg-white/[0.02] border border-white/10 rounded-2xl p-8 transition-all hover:border-blue-500/30 hover:-translate-y-1" data-id="element-1829" data-mp="1tmd8u4xwtvsp" data-mpi={i}>
                    
                    <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-5 ${feature.iconBg}`} data-id="element-1830" data-mp="1jmw9e5994e56">
                      
                      <IconComp className="w-5 h-5" data-id="element-1831" data-mp="1eqxgc4cza7yf" />
                    </div>
                    <h3 className="text-lg font-semibold mb-2" data-id="element-1832" data-mp="8abskgt0wkxo">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-white/70 leading-relaxed" data-id="element-1833" data-mp="3c0l2cq7amim">
                      {feature.desc}
                    </p>
                  </motion.div>;
            })}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── THE NUMBERS / ROI ── */}
      <section className="relative w-full bg-navy-light py-24 px-6 text-center" data-id="element-1834" data-mp="1i3kt5j2ja3ty">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-1835" data-mp="1n5a3sxlugfhi" />
        <div className="max-w-5xl mx-auto" data-id="element-1836" data-mp="2ft5zq03la3d8">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} data-id="element-1837" data-mp="2fs4q80281oxm">
            
            <motion.div variants={fadeUp} className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-4" data-id="element-1838" data-mp="25uqiqpya0ahg">
              
              The Numbers
            </motion.div>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4" data-id="element-1839" data-mp="ug34vxih9nvq">
              
              Manual receiving is costing you more than you think
            </motion.h2>
            <motion.p variants={fadeUp} className="text-lg text-white/70 mb-16 max-w-2xl mx-auto leading-relaxed" data-id="element-1840" data-mp="33pkhokcd4g3p">
              
              At 25 shipments a day and 10 minutes saved per shipment,
              ReceivePro pays for itself in the first week.
            </motion.p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-1841" data-mp="2px4ijuml1282">
              {[{
              num: '10s',
              color: 'text-blue-400',
              label: 'Per shipment',
              sub: 'was 8–15 min'
            }, {
              num: '<15m',
              color: 'text-teal-400',
              label: 'Dock-to-stock',
              sub: 'was 2–6 hours'
            }, {
              num: '98%',
              color: 'text-green-400',
              label: '3-way match rate',
              sub: 'was 78–88%'
            }, {
              num: '<0.5%',
              color: 'text-amber-400',
              label: 'Error rate',
              sub: 'was 3–8%'
            }].map((stat, i) => <motion.div key={i} variants={fadeUp} className="p-4" data-id="element-1842" data-mp="a5z2h685w8x2" data-mpi={i}>
                  <div className={`font-mono text-4xl md:text-5xl font-bold mb-2 ${stat.color}`} data-id="element-1843" data-mp="a3w5u3ci7hjd">
                  
                    {stat.num}
                  </div>
                  <div className="text-sm text-white/70 font-medium" data-id="element-1844" data-mp="jviqsren8uzb">
                    {stat.label}
                  </div>
                  <div className="text-xs text-white/40 mt-1" data-id="element-1845" data-mp="3ig22ybv3tmzf">{stat.sub}</div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── INTEGRATIONS ── */}
      <section id="integrations" className="relative w-full bg-navy py-24 px-6 text-center overflow-hidden" data-id="element-1846" data-mp="15kica6xozv5">
        
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-1847" data-mp="17m5z3dsh1mme" />
        <div className="max-w-4xl mx-auto" data-id="element-1848" data-mp="1cj66pt4yyxfm">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} data-id="element-1849" data-mp="2x2icmngueyev">
            
            <motion.div variants={fadeUp} className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-4" data-id="element-1850" data-mp="2s4gqtus18kzp">
              
              Integrations
            </motion.div>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4" data-id="element-1851" data-mp="2idce71ptxc81">
              
              Works with your ERP — whatever it is
            </motion.h2>
            <motion.p variants={fadeUp} className="text-lg text-white/70 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-1852" data-mp="29bw2mqna3428">
              
              ReceivePro is built as a companion to Thruline, but it connects to
              any system of record. You don't need to switch ERPs to use it.
            </motion.p>
          </motion.div>
        </div>

        <ERPLogoMarquee data-id="element-1853" data-mp="3tsixibe3cuqw" />
      </section>

      {/* ── PRICING ── */}
      <section id="pricing" className="relative w-full bg-navy-light py-24 px-6" data-id="element-1854" data-mp="3tr7tqbknbmzs">
        
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-1855" data-mp="32prmuduqt9im" />
        <div className="max-w-6xl mx-auto" data-id="element-1856" data-mp="2syetfhtaqbah">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="text-center mb-16" data-id="element-1857" data-mp="2sxlmoguc7lsc">
            
            <motion.div variants={fadeUp} className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-4" data-id="element-1858" data-mp="2jvvu37opygsz">
              
              Pricing
            </motion.div>
            <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4" data-id="element-1859" data-mp="2a0axxq6c0ar5">
              
              Simple pricing that scales with your dock
            </motion.h2>
            <motion.p variants={fadeUp} className="text-lg text-white/70 max-w-2xl mx-auto leading-relaxed" data-id="element-1860" data-mp="885yzuqf0d6x">
              
              Every plan includes the full AI agent pipeline, carrier tracking
              enrichment, Expected Receipts, and inspection notices. No feature
              gating.
            </motion.p>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={stagger} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-1861" data-mp="27eberet1grqz">
            
            {/* Starter */}
            <motion.div variants={fadeUp} className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-8 flex flex-col" data-id="element-1862" data-mp="2gdg908xkhyxc">
              
              <div className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-1" data-id="element-1863" data-mp="2qd73iam4odxf">
                Starter
              </div>
              <div className="text-white/50 text-sm mb-4" data-id="element-1864" data-mp="2lfnqtf52w97l">Single Location</div>
              <div className="mb-1" data-id="element-1865" data-mp="vymq8j04zko2">
                <span className="text-4xl font-bold text-white" data-id="element-1866" data-mp="vzob1f6yfliz">$499</span>
                <span className="text-white/40 text-base ml-1" data-id="element-1867" data-mp="r1mtiyp6fu9m">/month</span>
              </div>
              <div className="text-xs text-white/40 mb-6" data-id="element-1868" data-mp="2io3go48stche">
                Includes 450 scans/month$1.50 per additional scan
              </div>
              <hr className="border-white/[0.06] mb-6" data-id="element-1869" data-mp="2elql28nrmuyc" />
              <ul className="space-y-3 flex-1 mb-8" data-id="element-1870" data-mp="2sdmyr7oot2b7">
                {[{
                text: '1 location',
                included: true
              }, {
                text: 'Up to 5 users',
                included: true
              }, {
                text: '450 scans/month included',
                included: true
              }, {
                text: 'Full AI extraction + auto-receive',
                included: true
              }, {
                text: '1 ERP integration (Thruline, NetSuite, SAP B1, Epicor, or other)',
                included: true
              }, {
                text: 'Carrier tracking enrichment',
                included: true
              }, {
                text: 'Expected Receipts',
                included: true
              }, {
                text: 'Quality inspection notices',
                included: true
              }, {
                text: 'Email + chat support',
                included: true
              }, {
                text: 'Multi-location support',
                included: false
              }, {
                text: 'Custom integrations',
                included: false
              }].map((item, i) => <li key={i} className={`flex items-start gap-2.5 text-sm ${item.included ? 'text-white/70' : 'text-white/25'}`} data-id="element-1871" data-mp="1lkiiswzg6im9" data-mpi={i}>
                  
                    {item.included ? <CheckIcon className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-1872" data-mp="1buyvnf4pc2ll" /> : <XIcon className="w-4 h-4 text-white/20 mt-0.5 flex-shrink-0" data-id="element-1873" data-mp="1bup7lx37w5ij" />}
                    {item.text}
                  </li>)}
              </ul>
              <button onClick={() => setShowDemoVideo(true)} className="inline-flex items-center justify-center gap-2 w-full px-6 py-3 rounded-xl border border-white/20 text-white font-semibold text-sm hover:border-white/40 hover:bg-white/[0.03] transition-all" data-id="element-1874" data-mp="24jcsvsnyuuw3">
                
                <PlayIcon className="w-4 h-4" data-id="element-1875" data-mp="2e7i8dzn6q6cr" />
                See Demo Video
              </button>
            </motion.div>

            {/* Professional — Featured */}
            <motion.div variants={fadeUp} className="rounded-2xl border border-blue-500/30 bg-blue-500/[0.06] p-8 flex flex-col relative" data-id="element-1876" data-mp="29a8g8c8evgl8">
              
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-0.5 rounded-full bg-blue-500 text-white text-[10px] font-bold tracking-wider uppercase" data-id="element-1877" data-mp="208ir5d204tqm">
                Most Popular
              </div>
              <div className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-1" data-id="element-1878" data-mp="1qi5x8u8aro7t">
                Professional
              </div>
              <div className="text-white/50 text-sm mb-4" data-id="element-1879" data-mp="1gj8ds5pqakvo">Multi-Location</div>
              <div className="mb-1" data-id="element-1880" data-mp="1glkvqivhkv8q">
                <span className="text-4xl font-bold text-white" data-id="element-1881" data-mp="1chd4of1k337c">$999</span>
                <span className="text-white/40 text-base ml-1" data-id="element-1882" data-mp="3o58feroepdko">/month</span>
              </div>
              <div className="text-xs text-white/40 mb-6" data-id="element-1883" data-mp="3s6tp645n9bqn">
                Unlimited scans included
              </div>
              <hr className="border-blue-500/20 mb-6" data-id="element-1884" data-mp="100px5uevmor" />
              <ul className="space-y-3 flex-1 mb-8" data-id="element-1885" data-mp="11bw1cbbx6j1">
                {['Up to 5 locations', 'Up to 25 users', 'Unlimited scans', 'Full AI extraction + auto-receive', 'Up to 3 ERP / system integrations', 'Carrier tracking enrichment', 'Expected Receipts + bulk CSV import', 'Quality inspection notices', 'Multi-system PO matching (ERP + procurement + TMS)', 'Linked records (PO, PR, receipt ticket, transport ticket)', 'Priority support + onboarding'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-white/70" data-id="element-1886" data-mp="3j6f14x1apijg" data-mpi={i}>
                  
                    <CheckIcon className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-1887" data-mp="2lpq4dhr7d6gx" />
                    {item}
                  </li>)}
              </ul>
              <a href="https://calendly.com/alex-thruline/sales-call" className="inline-flex items-center justify-center w-full px-6 py-3 rounded-xl bg-blue-500 text-white font-semibold text-sm hover:bg-blue-400 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(59,130,246,0.3)]" data-id="element-1888" data-mp="2qnhxgf3l2ymp">
                
                Get a Demo
              </a>
            </motion.div>

            {/* Enterprise */}
            <motion.div variants={fadeUp} className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-8 flex flex-col" data-id="element-1889" data-mp="1fxd35nd1n9vz">
              
              <div className="font-mono text-xs text-blue-400 tracking-[0.1em] uppercase mb-1" data-id="element-1890" data-mp="1ay0fj0eclysc">
                Enterprise
              </div>
              <div className="text-white/50 text-sm mb-4" data-id="element-1891" data-mp="1jz6xzf0k5jo8">Custom</div>
              <div className="mb-1" data-id="element-1892" data-mp="1jzzvrqhjgyu8">
                <span className="text-4xl font-bold text-white" data-id="element-1893" data-mp="3qpehsuxdgvz4">Custom</span>
              </div>
              <div className="text-xs text-white/40 mb-6" data-id="element-1894" data-mp="3lqthkvi4ecao">
                For complex operations with advanced requirements
              </div>
              <hr className="border-white/[0.06] mb-6" data-id="element-1895" data-mp="219u6hex3sg5w" />
              <ul className="space-y-3 flex-1 mb-8" data-id="element-1896" data-mp="267cf1477ktdd">
                {['Unlimited locations', 'Unlimited users', 'Unlimited scans', 'Full AI extraction + auto-receive', 'Unlimited integrations + custom connectors', 'Carrier tracking enrichment', 'Expected Receipts + ASN auto-import', 'All inspection notice types', 'Custom approval workflows', 'Dedicated onboarding + SLA', 'SSO / SAML + audit logging'].map((item, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-white/70" data-id="element-1897" data-mp="1nhnoroeay14c" data-mpi={i}>
                  
                    <CheckIcon className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-1898" data-mp="19i4unzibsqb1" />
                    {item}
                  </li>)}
              </ul>
              <a href="https://calendly.com/alex-thruline/sales-call" className="inline-flex items-center justify-center w-full px-6 py-3 rounded-xl border border-white/20 text-white font-semibold text-sm hover:border-white/40 hover:bg-white/[0.03] transition-all" data-id="element-1899" data-mp="1dkro24unajac">
                
                Talk to Sales
              </a>
            </motion.div>
          </motion.div>

          {/* ROI comparison note */}
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-sm text-white/40 text-center max-w-3xl mx-auto leading-relaxed" data-id="element-1900" data-mp="bntygelbj2i8">
            
            <strong className="text-white/60" data-id="element-1901" data-mp="zehc7ghx0mcp">The math is simple:</strong> at 25
            shipments/day and 10 minutes saved per shipment, ReceivePro saves ~4
            hours of dock labor daily. At $25/hour fully loaded, that's
            $2,200/month in labor alone — before counting error reduction,
            faster three-way match, and inventory accuracy. The Starter plan
            pays for itself in the first week.
          </motion.p>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="relative w-full bg-navy py-32 px-6 text-center overflow-hidden" data-id="element-1902" data-mp="1pogouzjwm9v5">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" data-id="element-1903" data-mp="1unkx9nz083kf" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-blue-500/5 pointer-events-none" data-id="element-1904" data-mp="1znphnp319ifx" />

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={stagger} className="relative z-10 max-w-3xl mx-auto" data-id="element-1905" data-mp="23kvc1jb16au3">
          
          <motion.h2 variants={fadeUp} className="text-4xl sm:text-5xl font-bold tracking-tight mb-6" data-id="element-1906" data-mp="2ic45k3i20gci">
            
            Get something built today
          </motion.h2>
          <motion.p variants={fadeUp} className="text-xl text-white/70 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-1907" data-mp="2nadzkas1lawj">
            
            See ReceivePro with your own PO data. We'll set up a pilot in days,
            not months.
          </motion.p>
          <motion.div variants={fadeUp} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1908" data-mp="3hmanytopigwy">
            
            <a href="https://calendly.com/alex-thruline/sales-call" className="inline-flex items-center justify-center px-8 py-3.5 rounded-xl bg-blue-500 text-white font-semibold text-base hover:bg-blue-400 transition-all hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(59,130,246,0.3)]" data-id="element-1909" data-mp="3cmxtpnvia7kc">
              
              Get a Demo
            </a>
            <button onClick={() => setShowDemoVideo(true)} className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl border border-white/20 text-white font-semibold text-base hover:border-white/40 hover:bg-white/[0.03] transition-all" data-id="element-1910" data-mp="2tx9aut4xihlc">
              
              <PlayIcon className="w-4 h-4" data-id="element-1911" data-mp="33tce62biom9v" />
              See Demo Video
            </button>
          </motion.div>
        </motion.div>
      </section>

      {/* ── LOOM VIDEO MODAL ── */}
      <AnimatePresence data-id="element-1912" data-mp="2b6hxzhlqg927">
        {showDemoVideo && <>
            <motion.div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowDemoVideo(false)} data-id="element-1913" data-mp="qofqjdkmjia4" />
          
            <motion.div className="fixed inset-0 z-[101] flex items-center justify-center p-4 sm:p-6 pointer-events-none" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-1914" data-mp="lpmcnk1fdp9f">
            
              <motion.div className="relative w-full max-w-5xl pointer-events-auto" initial={{
            scale: 0.95,
            y: 20
          }} animate={{
            scale: 1,
            y: 0
          }} exit={{
            scale: 0.95,
            y: 20
          }} transition={{
            duration: 0.25,
            ease: [0.16, 1, 0.3, 1]
          }} onClick={e => e.stopPropagation()} data-id="element-1915" data-mp="1edrzqdfybqcf">
              
                <button onClick={() => setShowDemoVideo(false)} className="absolute -top-12 right-0 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors" aria-label="Close video" data-id="element-1916" data-mp="3p48m621fu5kv">
                
                  <XIcon className="w-6 h-6 text-white" data-id="element-1917" data-mp="2t7ig9o0uzs2l" />
                </button>
                <div className="relative rounded-2xl overflow-hidden bg-navy border border-white/10 shadow-2xl" data-id="element-1918" data-mp="2x82dsspcgxp9">
                  <div className="aspect-video" data-id="element-1919" data-mp="323zskukylvzx">
                    <iframe src={`https://www.loom.com/embed/${LOOM_VIDEO_ID}?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true`} frameBorder="0" allowFullScreen className="w-full h-full" data-id="element-1920" data-mp="25h4hzfrokwzk" />
                  
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}